import { Box, Typography } from "@mui/material";
import { motion, useReducedMotion } from "framer-motion";
import PageLayout from "../../layoutcontainers/PageLayout";
import assets from "../../config/assestsConfig";
import heroImage from "../../assest/keel_background.png";

const LogInLayout = ({ children }) => {
  const shouldReduceMotion = useReducedMotion();

  return (
    <PageLayout height="100%" showNavbar disableFooter>
      <Box className="login-shell">
        <Box className="login-hero">
          <motion.div
            className="login-hero-copy"
            // initial={shouldReduceMotion ? false : { opacity: 1, y: 16 }}
            // animate={{
            //   opacity: 1,
            //   y: shouldReduceMotion ? 0 : [0, -5, 0],
            // }}
            // transition={{
            //   opacity: { duration: 0.55, ease: "easeOut" },
            //   y: shouldReduceMotion
            //     ? { duration: 0 }
            //     : { duration: 6, repeat: Infinity, ease: "easeInOut" },
            // }}
          >
            <Typography component="h1">HR that feels<br /><em>alive every day.</em></Typography>
            <Typography>Attendance, payroll, leaves and cheers — one fresh workspace<br className="desktop-break" /> your team will actually love to open.</Typography>
          </motion.div>
          <Box className="login-activity-cards" aria-label="Recent team activity">
            <motion.div
              className="login-activity-card login-leave-card"
              initial={shouldReduceMotion ? false : { opacity: 1, x: -8, y: 8 }}
              animate={{
                opacity: 1,
                x: shouldReduceMotion ? 0 : [0, -7, 0],
                y: shouldReduceMotion ? 0 : [0, -11, 0],
                rotate: shouldReduceMotion ? -2 : [-2, -4, -2],
                scale: 1,
              }}
              transition={{
                opacity: { duration: 0.55, delay: 0.15 },
                x: shouldReduceMotion
                  ? { duration: 0 }
                  : { duration: 5.8, delay: 0.7, repeat: Infinity, ease: "easeInOut" },
                y: shouldReduceMotion
                  ? { duration: 0 }
                  : { duration: 4.6, delay: 0.7, repeat: Infinity, ease: "easeInOut" },
                rotate: shouldReduceMotion
                  ? { duration: 0 }
                  : { duration: 6.5, delay: 0.7, repeat: Infinity, ease: "easeInOut" },
              }}
            >
              <span className="login-activity-mark">✓</span>
              <Box>
                <Typography className="login-activity-label">LEAVE APPROVED</Typography>
                <Typography className="login-activity-detail">Aisha · 12–15 Aug · Bali</Typography>
              </Box>
            </motion.div>
            <motion.div
              className="login-activity-card login-payroll-card"
              initial={shouldReduceMotion ? false : { opacity: 1, x: 8, y: 8 }}
              animate={{
                opacity: 1,
                x: shouldReduceMotion ? 0 : [0, 8, 0],
                y: shouldReduceMotion ? 0 : [0, 10, 0],
                rotate: shouldReduceMotion ? 1 : [1, 3, 1],
                scale: 1,
              }}
              transition={{
                opacity: { duration: 0.55, delay: 0.3 },
                x: shouldReduceMotion
                  ? { duration: 0 }
                  : { duration: 6.2, delay: 1, repeat: Infinity, ease: "easeInOut" },
                y: shouldReduceMotion
                  ? { duration: 0 }
                  : { duration: 5.2, delay: 1, repeat: Infinity, ease: "easeInOut" },
                rotate: shouldReduceMotion
                  ? { duration: 0 }
                  : { duration: 7.2, delay: 1, repeat: Infinity, ease: "easeInOut" },
              }}
            >
              <span className="login-activity-mark">₹</span>
              <Box>
                <Typography className="login-activity-label">JULY PAYROLL</Typography>
                <Typography className="login-activity-detail">
                  <strong>₹42000</strong><span>+12.4% vs June</span>
                </Typography>
              </Box>
            </motion.div>
            <motion.div
              className="login-activity-card login-checkin-card"
              initial={shouldReduceMotion ? false : { opacity: 1, x: -8, y: 8 }}
              animate={{
                opacity: 1,
                x: shouldReduceMotion ? 0 : [0, -8, 0],
                y: shouldReduceMotion ? 0 : [0, -9, 0],
                rotate: shouldReduceMotion ? -1 : [-1, -3, -1],
                scale: 1,
              }}
              transition={{
                opacity: { duration: 0.55, delay: 0.45 },
                x: shouldReduceMotion
                  ? { duration: 0 }
                  : { duration: 5.5, delay: 1.3, repeat: Infinity, ease: "easeInOut" },
                y: shouldReduceMotion
                  ? { duration: 0 }
                  : { duration: 4.8, delay: 1.3, repeat: Infinity, ease: "easeInOut" },
                rotate: shouldReduceMotion
                  ? { duration: 0 }
                  : { duration: 7.5, delay: 1.3, repeat: Infinity, ease: "easeInOut" },
              }}
            >
              <span className="login-activity-mark">●</span>
              <Box>
                <Typography className="login-activity-label">CHECK-IN · 9:02 AM</Typography>
                <Typography className="login-activity-detail">
                  Koramangala <strong>On time</strong>
                </Typography>
              </Box>
            </motion.div>
            <motion.div
              className="login-insight-card"
              aria-label="Team attendance overview"
              initial={shouldReduceMotion ? false : { opacity: 1, x: 8, y: 8 }}
              animate={{
                opacity: 1,
                x: shouldReduceMotion ? 0 : [0, 7, 0],
                y: shouldReduceMotion ? 0 : [0, 8, 0],
                rotate: shouldReduceMotion ? 0 : [0, 2, 0],
                scale: 1,
              }}
              transition={{
                opacity: { duration: 0.6, delay: 0.6 },
                x: shouldReduceMotion
                  ? { duration: 0 }
                  : { duration: 6.8, delay: 1.5, repeat: Infinity, ease: "easeInOut" },
                y: shouldReduceMotion
                  ? { duration: 0 }
                  : { duration: 5.8, delay: 1.5, repeat: Infinity, ease: "easeInOut" },
                rotate: shouldReduceMotion
                  ? { duration: 0 }
                  : { duration: 8, delay: 1.5, repeat: Infinity, ease: "easeInOut" },
              }}
            >
              <Box className="login-insight-heading">
                <span>TEAM PULSE</span>
                <span className="login-insight-live"><i /> LIVE</span>
              </Box>
              <Box className="login-insight-summary">
                <span>Attendance</span>
                <strong>96.8%</strong>
              </Box>
              <Box className="login-chart" aria-hidden="true">
                {[42, 64, 50, 82, 61, 92, 73, 100, 79, 88, 68, 96].map(
                  (height, index) => (
                    <motion.span
                      key={index}
                      initial={false}
                      animate={{ scaleY: shouldReduceMotion ? 1 : [1, 0.72, 1] }}
                      transition={{
                        duration: shouldReduceMotion ? 0 : 2.8,
                        delay: shouldReduceMotion ? 0 : index * 0.09,
                        repeat: shouldReduceMotion ? 0 : Infinity,
                        ease: "easeInOut",
                      }}
                      style={{ "--bar-height": `${height}%`, "--bar-index": index }}
                    />
                  )
                )}
              </Box>
              <Box className="login-insight-foot">
                <span>On-time check-ins</span>
                <strong>↑ 8.4%</strong>
              </Box>
            </motion.div>
          </Box>
          <motion.div
            className="login-hero-art"
            // initial={shouldReduceMotion ? false : { opacity: 1, y: 22, scale: 0.97 }}
            // animate={{
            //   opacity: 1,
            //   y: shouldReduceMotion ? 0 : [0, -16, 0],
            //   scale: shouldReduceMotion ? 1 : [1, 1.018, 1],
            //   rotate: shouldReduceMotion ? 0 : [0, 0.6, 0],
            // }}
            // transition={{
            //   opacity: { duration: 0.7, delay: 0.2 },
            //   y: shouldReduceMotion
            //     ? { duration: 0 }
            //     : { duration: 5.6, delay: 0.8, repeat: Infinity, ease: "easeInOut" },
            //   scale: shouldReduceMotion
            //     ? { duration: 0 }
            //     : { duration: 8, delay: 0.8, repeat: Infinity, ease: "easeInOut" },
            //   rotate: shouldReduceMotion
            //     ? { duration: 0 }
            //     : { duration: 7, delay: 0.8, repeat: Infinity, ease: "easeInOut" },
            // }}
          >
            <motion.img
              src={heroImage}
              alt="Happy office team"
              // initial={false}
              // animate={{ scale: shouldReduceMotion ? 1 : [1.02, 1.09, 1.02] }}
              // transition={{
              //   duration: 10,
              //   repeat: shouldReduceMotion ? 0 : Infinity,
              //   ease: "easeInOut",
              // }}
            />
            <motion.div
              className="login-status-card"
              initial={false}
              // animate={{
              //   opacity: 1,
              //   y: shouldReduceMotion ? 0 : [0, -3, 0],
              // }}
              // transition={{
              //   opacity: { duration: 0.5, delay: 0.8 },
              //   y: { duration: 5.5, delay: 1.4, repeat: Infinity, ease: "easeInOut" },
              // }}
            >
              <strong>✓</strong> All systems normal
            </motion.div>
          </motion.div>
        </Box>

        <Box className="login-rail">
          <Box className="login-brand">
            <motion.img
              src={assets.logo}
              alt="HRMS"
              initial={false}
              // animate={{ opacity: 1, scale: 1 }}
              // transition={{ duration: 0.1, ease: "easeOut" }}
            />
          </Box>

          <Box className="login-form-area">
            <Typography className="login-title">Welcome back! Let’s make work simple.<span aria-hidden="true">👋</span></Typography>
            {children}
          </Box>

          <Box component="footer" className="login-footer">
            <span>© 2026</span>
            <a href="https://www.keelis.com/" target="_blank" rel="noopener noreferrer">
              Keel info solution pvt. ltd.
            </a>
            <a className="login-support-contact" href="tel:+919087599222">
              Support: +91 90875 99222
            </a>
            <a href="/privacy-policy">Privacy</a>
            <a
              href="mailto:support@keelis.com?subject=Terms%20and%20Conditions"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms
            </a>
            <a href="https://www.keelis.com/contact" target="_blank" rel="noopener noreferrer">
              Help
            </a>
          </Box>
        </Box>
      </Box>
    </PageLayout>
  );
};

export default LogInLayout;
